import { Typography, Card, ButtonBase, CardContent, Stack, Box, CardMedia, Link } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useMemo } from "react";
import { Link as RouterLink, useLocation, useParams } from "react-router-dom";
import ItemDto from "../../../models/ItemDto";
import { currencyFormat } from "../../../utils/Utils";
import { ITEM_URL, MENU_CARD_URL, SUB_CATEGORY_URL, CATEGORY_URL, SEARCH_URL } from "../../../utils/Constants";
import CurrencyDto from "../../../models/CurrencyDto";
import { useRestaurantData } from "../../../provider/RestaurantDataContext";

interface ItemListCardItemProps {
    item: ItemDto;
    currency: CurrencyDto;
    categoryId?: number;
    subCategoryId?: number;
}

export default function ItemListCardItem({ item, currency, categoryId, subCategoryId }: ItemListCardItemProps) {
    const { live } = useRestaurantData();
    const params = useParams();
    const location = useLocation();
    const searchResult = useMemo(() => location.pathname.includes(SEARCH_URL), [location.pathname]);
    const url = useMemo(() =>
        searchResult ?
            `/qr-menu/${params.restaurantId}/${MENU_CARD_URL}/${CATEGORY_URL}/${categoryId}/${SUB_CATEGORY_URL}/${subCategoryId}/${ITEM_URL}/${item.id}` :
            `${ITEM_URL}/${item.id}`,
        [item.id, params.restaurantId, searchResult, categoryId, subCategoryId]);
    const hasImage = item.imageUrl && item.imageUrl.length > 0;

    const disabled = useMemo(() => live && item.disabled, [live, item.disabled]);

    const priceTag = useMemo(() => (
        <Typography sx={{ fontSize: '1rem', fontWeight: 'bold', textAlign: 'right' }}>
            {currencyFormat(item.price) + currency.detail}
        </Typography>
    ), [item.price, currency.detail]);

    return (
        <Card style={{
            height: 'auto', borderRadius: '1rem',
            background: "rgba(250,250,250, 255)",
            boxShadow: "0 0 0.625rem rgb(33, 103, 253)",
            border: 1,
            width: '100%'
        }} sx={{ border: 1 }} >
            <Link component={RouterLink} relative="path" to={url} style={{ textDecoration: 'none', width: '100%', pointerEvents: disabled ? 'none' : undefined, opacity: disabled ? 0.3 : 1 }}>
                <ButtonBase
                    style={{ width: '100%', height: '100%' }}>
                    <CardContent sx={{ width: '100%', p: '0.5rem' }}>
                        <Grid2 container direction="row" columnSpacing={1} style={{ width: '100%' }}
                            justifyContent=""
                            columns={18}>
                            <Grid2 xs={2} display="flex" justifyContent="center" alignItems="center">
                                <Stack direction="column" spacing={0} justifyContent="center" alignItems="center" sx={{ maxWidth: '100%' }}>
                                    {
                                        item.foodTypes.map((foodType) => (
                                            <Box key={foodType.id} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', maxWidth: '100%' }}>
                                                <Box sx={{ flexGrow: '1', maxWidth: '100%' }}>
                                                </Box>
                                            </Box>
                                        ))
                                    }
                                </Stack>
                            </Grid2>
                            <Grid2 xs={16} display="flex" justifyContent="center" alignItems="center">
                                <Grid2 container direction="row" columnSpacing={1} alignItems={!hasImage ? 'center' : ''} style={{ width: '100%' }}
                                    justifyContent="center"
                                    columns={16}>
                                    {hasImage &&
                                        <>
                                            <Grid2 xs={14} sx={{ display: 'flex', justifyContent: 'center' }}>
                                                <CardMedia
                                                    component="img"
                                                    image={item.imageUrl}
                                                    alt={item.value.value}
                                                    sx={{ maxHeight: '5rem', width: 'auto', maxWidth: '100%', borderRadius: '0.625rem', boxShadow: '0.25rem 0.25rem 0.563rem rgb(37, 37, 37)' }}
                                                />
                                            </Grid2>
                                            <Grid2 xs={2} display="flex" justifyContent="flex-end" >
                                                <InfoOutlinedIcon fontSize="large" color="primary" />
                                            </Grid2>
                                        </>
                                    }
                                    <Grid2 xs={14}>
                                        <Typography sx={{ mt: '0.5rem', fontSize: '1.1rem', fontWeight: 'bold', color: 'black', textAlign: 'center', hyphens: 'auto' }}>
                                            {item.value.value}
                                        </Typography>
                                    </Grid2>
                                    {hasImage ?
                                        <>
                                            <Grid2 xs={2} />
                                            <Grid2 xs={16}>
                                                {priceTag}
                                            </Grid2>
                                        </> :
                                        <>
                                            <Grid2 xs={2}>
                                                <Stack direction='column' alignItems='flex-end'>
                                                    <InfoOutlinedIcon fontSize="large" color="primary" />
                                                    {priceTag}
                                                </Stack>
                                            </Grid2>
                                        </>
                                    }
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </CardContent>
                </ButtonBase>
            </Link>
        </Card>
    );
}